import React, { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, encoreContextStatus, getStatus } from "../../../contexts/EncoreContext";
import { Experimental__IconHelpCircle } from "../../Experimental__Icon/icons/Experimental__IconHelpCircle";
import { Icon } from "../";
/**
 * @deprecated The name IconHelpAlt is deprecated and will be archived soon. Use IconHelpCircle instead.
 */

export function IconHelpAlt(props) {
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.icon, config);

  if (status !== encoreContextStatus.deprecated) {
    return /*#__PURE__*/React.createElement(Experimental__IconHelpCircle, props);
  }

  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    dangerouslySetInnerHTML: {
      __html: "<circle cx=\"12\" cy=\"12\" r=\"9.5\" fill=\"none\" stroke=\"#181818\"/><path d=\"M9.72 10.26a2.65 2.65 0 01.52-2.43 2.67 2.67 0 013-.64 2.39 2.39 0 011.44 1.93 2.67 2.67 0 01-1.18 2.28c-.38.33-1.33.83-1.46 1.7 0 .33-.05 1.18-.05 1.18\" fill=\"none\" stroke=\"#181818\"/><circle cx=\"12\" cy=\"16.65\" r=\".35\" fill=\"#181818\" stroke=\"#181818\"/>"
    }
  }));
}
export default IconHelpAlt;